import { Component, Inject, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { Validators, UntypedFormControl, UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { Global } from '../../../../shared/global';
import { DateService } from '../../../service/date.service';
import { Subject, interval, BehaviorSubject } from 'rxjs';
import { debounce } from 'rxjs/operators';
import { OffertService } from '../../../service/offert.service';
import { PopupService } from '../../../service/popup.service';
import { MessageService } from '../../../service/message.service';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { IOffert } from '../../../models/offert';
import { getQuery, toggleEditMode } from '../../../../shared/utils';
import { ErrorMessageType } from '../../../../shared/enum';

@Component({
  selector: 'app-offert-verification-dialog',
  templateUrl: './offert-verification-dialog.component.html',
  styleUrls: ['./offert-verification-dialog.component.scss']
})
export class OffertVerificationDialogComponent implements OnInit {

  formGroup: UntypedFormGroup;

  privatperson: boolean;
  attemptCount: number;

  getOffertById$ = new Subject();
  sendPasscodeResetLink$ = new Subject();
  passcodeResetResponse$ = new BehaviorSubject<HttpResponse<Response>>(null);

  geburtsdatumMinDate = Global.GEBURTSDATUM_MIN_DATE;
  geburtsdatumMaxDate: Date;

  constructor(private dialogRef: MatDialogRef<OffertVerificationDialogComponent>, private dateService: DateService,
    private offertService: OffertService, private route: ActivatedRoute, private popupService: PopupService, private messageService: MessageService, private router: Router,
    private fb: UntypedFormBuilder, private location: Location, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.privatperson = this.data.privatperson;
    this.geburtsdatumMaxDate = this.dateService.today();

    this.getOffertById$
      .pipe(debounce(() => interval(300)))
      .subscribe(() => {
        this.getOffertById();
      });

    this.sendPasscodeResetLink$
      .pipe(debounce(() => interval(300)))
      .subscribe(() => {
        this.sendPasscodeResetLink();
      });
  }

  ngOnInit(): void {
    this.formGroup = this.fb.group({
      geburtsdatum: new UntypedFormControl('', Validators.required),
      passcode: new UntypedFormControl('', Validators.required)
    });

    this.toggleEditMode();
  }

  get geburtsdatum() { return this.formGroup.get('geburtsdatum'); }
  get passcode() { return this.formGroup.get('passcode'); }

  get showGeburtsdatum() {
    return this.privatperson === true ? true : false;
  }

  get showPasscode() {
    return this.privatperson === false ? true : false;
  }

  toggleEditMode(): void {
    toggleEditMode(this.geburtsdatum, this.showGeburtsdatum);
    toggleEditMode(this.passcode, this.showPasscode);
  }

  getOffertById(): void {
    if (this.formGroup.valid) {
      this.offertService.getOffertById({
        Geburtsdatum: this.geburtsdatum.value,
        Passcode: this.passcode.value
      }, getQuery()).subscribe(
        (data) => {
          if (data.OffertBase) {
            this.returnToRechner(data.OffertBase);
          } else {
            this.attemptCount = data.AttemptCount;
          }
        },
        (err: HttpErrorResponse) => {
          this.popupService.openErrorPopup(this.messageService.generateErrorMessage(ErrorMessageType.General));
          console.log(err.message);
        }
      );
    }
  }

  sendPasscodeResetLink(): void {
    this.offertService.sendPasscodeResetLink(getQuery()).subscribe(
      (data) => {
        this.passcodeResetResponse$.next(data);
      },
      (err: HttpErrorResponse) => {
        this.popupService.openErrorPopup(this.messageService.generateErrorMessage(ErrorMessageType.General));
        console.log(err.message);
      }
    );
  }

  returnToRechner(offert: IOffert = null): void {
    const route = this.router.url.split('/')[1];
    this.location.replaceState(route);
    this.dialogRef.close(offert);
  }
}
